<template>
  <div v-if="list" class="additionalPaddingOnSides">
    <div v-if="list.length > 0" class="dropdown dropdown-form-control">
      <button type="button" class="dropdown-toggle" data-toggle="dropdown" data-display="static">
        <span class="dropdown-name">{{ chosen ? chosen.name : label }}</span>
        <span class="dropdown-icon">
          <font-awesome-icon :icon="['fas', 'angle-down']" />
        </span>
      </button>
      <div class="dropdown-menu">
        <a
          v-for="(listItem, index) in list"
          class="dropdown-item"
          href="#"
          @click.prevent="selected(listItem)"
        >{{listItem.name}}</a>
      </div>
      <span v-if="error" class="vv-error">{{ error }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['list', 'chosen', 'label', 'name', 'error'],
  data() {
    return {};
  },
  methods: {
    selected(value) {
      this.$emit('selected', this.name, value);
    },
    getCorrectYearDisplay(value) {
      if (value) {
        return value.toString().slice(0, 4) + '/' + value.toString().slice(4, 6);
      } else {
        return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dropdown-form-control {
  margin-bottom: 24px;
  border: 1px solid #ededed;

  ::-webkit-scrollbar {
    display: block !important;
  }

  ::-webkit-scrollbar {
    display: block !important;
  }

  ::-webkit-scrollbar {
    width: 10px !important;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: white !important;
    border-radius: 5px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888 !important;
    border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555 !important;
  }

  button {
    outline: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: 0;
    .dropdown-name {
      padding: 0.375rem 0 0.375rem 0.75rem;
    }
    .dropdown-icon {
      background: #ededed;
      width: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0 1.1rem 1.1rem 0;
      height: 36px;
      margin-right: -0.3px;
    }
  }

  .dropdown-menu.show {
    width: 100.5%;
    left: -1px !important;
    margin-top: 0px;
    overflow-y: auto;
    max-height: 200px;
    border: 1px solid #ededed;
    box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1);
  }

  &.show {
    outline: none;
    border-radius: 1.1rem 1.1rem 0 0;
    .dropdown-icon {
      border-radius: 0 1.1rem 0 0;
      svg {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
